import { RouteState } from './route-state';
import { FacetValue, FacetFilter, isRangeFilter } from '@app/core/search/filtering/types';
import * as RANGE from '@app/core/search/common/range';

export class RouteStateBuilder {
  private routeState: RouteState;

  constructor(originalUrl: string, pathname?: string) {
    this.routeState = {
      originalUrl,
      params: {}
    };

    if (typeof pathname === 'string') {
      this.setPathname(pathname);
    }
  }

  static getParamValue(param: string, routeState: RouteState): string {
    if (param in routeState.params) {
      return routeState.params[param];
    }

    return null;
  }

  setPathname(pathname: string): RouteStateBuilder {
    this.routeState.pathname = pathname;
    return this;
  }

  setPage(page: string): RouteStateBuilder {
    this.routeState.params.page = page;
    return this;
  }

  setPageOffset(page: number): RouteStateBuilder {
    if (page > 0) {
      this.setPage(String(page));
    }
    return this;
  }

  setQuery(query: string): RouteStateBuilder {
    this.routeState.params.query = query;
    return this;
  }

  set(param: string, value: string): RouteStateBuilder {
    this.routeState.params[param] = value;
    return this;
  }

  setFacet(param: string, facet: FacetFilter, value: FacetValue): RouteStateBuilder {
    if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
      return this.setList(param, value);
    }
    if (typeof value === 'string' && isRangeFilter(facet.type)) {
      return this.setRange(param, RANGE.parse(value));
    }
    if (typeof value === 'boolean') {
      return this.setToggle(param, value);
    }

    return this.set(param, String(value));
  }

  setRange(param: string, value: RANGE.Range): RouteStateBuilder {
    if (value.min !== undefined && param === 'priceMin') {
      this.setNumeric(param.indexOf('Min') ? param : `${param}Min`, value.min);
    }
    if (value.max !== undefined && param === 'priceMax') {
      this.setNumeric(param.indexOf('Max') ? param : `${param}Max`, value.max);
    }
    return this;
  }

  setList(param: string, value: string[]): RouteStateBuilder {
    this.set(param, value.join('-'));
    return this;
  }

  setToggle(param: string, value: boolean): RouteStateBuilder {
    this.set(param, value ? '1' : '0');
    return this;
  }

  setNumeric(param: string, value: number): RouteStateBuilder {
    this.set(param, String(value));
    return this;
  }

  getState(): RouteState {
    return this.routeState;
  }
}
